import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { forEach } from '@angular/router/src/utils/collection';
import { FlashMessagesService } from "angular2-flash-messages";

export interface DialogData {
  orderData: any;
}
@Component({
  selector: 'app-refund-order',
  templateUrl: './refund-order.component.html',
  styleUrls: ['./refund-order.component.css']
})
export class RefundOrderComponent implements OnInit {
  //public refundData:any={};
  public isCalculateRefund = false;
  public loading=false;
  private result = '';
  constructor(public dialogRef: MatDialogRef<RefundOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit() {
    this.calculateRefundAll();
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getPrice = function () {
    this.loading = true;
    this.data.orderData.shop_id = localStorage.getItem("userID");
    this.CommonService.apiService(
      "POST",
      "store/get_prices",
      this.data.orderData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.isCalculateRefund = true;
          //this.data.priceData = response.data;
          this.data.orderData.total_quantity = response.data.total_quantity;
          this.data.orderData.tax = response.data.tax;
          this.data.orderData.tax_percentage = response.data.tax_percentage;
          this.data.orderData.shipping_price = response.data.shipping_price;
          this.data.orderData.total_price = response.data.total_price;
          this.data.orderData.grand_total_price = response.data.grand_total_price;
          console.log('orderData', this.data.orderData);
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );


  }

  refundOrder = function (type = 'full') {
    this.loading = true;
    this.data.orderData.shop_id = localStorage.getItem("userID");
    let refundData = JSON.parse(JSON.stringify(this.data.orderData));
    if (refundData) {
      delete refundData.address;
      delete refundData.header_img;
      delete refundData.headline;
      delete refundData.logo;
      delete refundData.mockup_data;
      delete refundData.personal_info;
      delete refundData.name;
      delete refundData.purchase_date;
      delete refundData.shipping_method;
      delete refundData.shipping_method_name;
      delete refundData.store_status;
      refundData.order_data.forEach((pvalue, pkey) => {
        delete pvalue.product[0].description;
        delete pvalue.product[0].image;
        delete pvalue.product[0].name;
        delete pvalue.product[0].product_title;
        delete pvalue.product[0].turn_around_times;
        delete pvalue.product[0].brand;
        pvalue.product.forEach((productValue, productKey) => {
          productValue.size.forEach((sizeValue, sizeKey) => {
            refundData.order_data[pkey].product[productKey].size[sizeKey].refunded = true;
          });
        });
      });
    }
    let options = {
      id: localStorage.getItem("userID"),
      invoice_id: refundData.customer_order_id,
      refund_data: refundData
    }
    this.CommonService.apiService(
      "POST",
      "store/refund",
      options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 4000
          });
          this.result = "success";
          this.dialogRef.close(this.result);
        } else {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-warning",
            timeout: 3000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );


  }

  calculateRefund(orderIndex, sizeIndex, currentQty, enteredQty) {
    // Adjust the entered quantity to not exceed the current quantity
    const updatedQty = Math.min(currentQty, enteredQty);
    this.data.orderData.order_data[orderIndex].product[0].quantity[sizeIndex] = updatedQty;
  
    this.calculateRefundAll();
  }

  calculateRefundAll() {
    let refundTotalQty = 0;
    let refundTotalPrice = 0;
  
    // Calculate total refund quantity and refund price
    this.data.orderData.order_data.forEach((order) => {
      order.product[0].size.forEach((_, sizeIndex) => {
        const quantity = parseFloat(order.product[0].quantity[sizeIndex]);
        const price = parseFloat(order.product[0].retail_price);
        refundTotalQty += quantity;
        refundTotalPrice += quantity * price;
      });
    });
  
    // Calculate per-item tax and shipping costs
    const totalQuantity = parseInt(this.data.orderData.total_quantity);
    const oneItemTax = parseFloat(this.data.orderData.tax) / totalQuantity;
    const oneItemShipping = parseFloat(this.data.orderData.shipping_price) / totalQuantity;
  
    // Compute refund breakdown
    this.data.orderData.refundTotalQty = refundTotalQty;
    this.data.orderData.refundTotalPrice = refundTotalPrice;
    this.data.orderData.refundTax = oneItemTax * refundTotalQty;
    this.data.orderData.refundShippingPrice = oneItemShipping * refundTotalQty;
  
    // Compute grand total refund amount
    this.data.orderData.refundGrandTotalPrice =
      refundTotalPrice +
      this.data.orderData.refundTax +
      this.data.orderData.refundShippingPrice;
  
    // Mark refund calculation as complete
    this.isCalculateRefund = true;
  }

  trackByFn(index: any, item: any) {
    return index;
  }



}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/refund-order/refund-order.component.ts